export const FirstSection = () => {
    return (
        <div className={"flex flex-col md:flex-row items-center justify-between pt-12 lg:p-6"}>
            <div className={"md:w-1/2 text-center md:text-left"}>
                <h2 className={"lg:text-3xl text-xl font-bold text-gray-800 mb-4"}>Nơi gặp gỡ giữa doanh nghiệp và 10
                    triệu ứng
                    viên chất lượng</h2>
                <p className={"lg:text-lg text-md text-gray-600 mb-4"}>Tuyển người dễ dàng với Vieclamsanxuat. Chúng tôi
                    luôn
                    có ứng viên phù hợp cho bạn</p>
                <button
                    className={"bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full transition duration-300"}>Liên
                    hệ tư vấn ngay!
                </button>
            </div>
            <div className={"md:w-1/2 mt-6 md:mt-0"}>
                <img src={"https://ntd.vieclam24h.vn/_next/image?url=%2Fimg%2Flanding_page_right.png&w=750&q=75"}
                     className={"w-full hidden lg:block rounded-lg p-4"} alt={"NewImg"}/>
            </div>
        </div>
    )
}